import { observable } from 'mobx';

export default class Message {
  @observable message;

  @observable messageType;

  constructor({ message = '', messageType = '' } = {}) {
    this.message = message;
    this.messageType = messageType;
  }
}